/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */

function toUpperCase(string) {
  return string.toUpperCase()
}

export default toUpperCase
